import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import AddParticipant from './AddParticipant';

const AddParticipantPage = () => {

  return (
    <Page
      pageId={Pages.SESSION_EDIT}
      navPhoto={{ image: '/images/activities/left_sidebar.jpg' }}
      title='Add Participant'
      breadcrumbs={['events', ':event', ':session', 'Add Participant']}
      requireAuth
    >
      <AddParticipant />
    </Page>
  )
};

export default AddParticipantPage;
